import { Injectable } from '@angular/core';
import * as companyActions from './company-list-actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { CompanyService } from '../../company.service';
@Injectable()
export class CompanyListEffects {
openCompanyDetailsForCustomer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(companyActions.openCompanyDetailsForCustomer),
        tap((action) => {
          localStorage.setItem("groupcode", action.groupCode);
          this.companyService.getLocalStorage();
          this.companyService.loadPremiumData();
          const navigateTo = action.navigateTo ? `/${action.currentYear}/${action.prfNumber}/${action.navigateTo}` : `/${action.currentYear}/${action.prfNumber}/companyinformation`;
          this.router.navigate([navigateTo]);

        })
      ),
    { dispatch: false }
  );

  navigateToValidationSummary$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(companyActions.navigateToValidationSummary),
        tap((action) => {
          const data = action;
          localStorage.setItem('year', data.currentYear + "");
          localStorage.setItem('groupcode', data.groupCode);
          this.companyService.getLocalStorage();
          this.companyService.loadPremiumData();
            this.router.navigate([`${data.currentYear}/${data.prfNumber}/validationsummary`]);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private companyService: CompanyService,
    private router: Router
  ) {}
  
}